module.exports = __webpack_public_path__ + "img/image1.8ae3a9d1.png";